import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../Icon/index.js";
import { responsivePropDependency } from "../../utilities/props.js";
import s from "./Select.module.css";
const SelectStartContent = (props) => {
    const { startSlot, icon, size } = props;
    if (!startSlot && !icon)
        return null;
    if (icon) {
        return (_jsx("div", { className: s.slot, children: _jsx(Icon, { size: responsivePropDependency(size, (size) => {
                    if (size === "large")
                        return 5;
                    if (size === "xlarge")
                        return 6;
                    return 4;
                }), svg: icon }) }));
    }
    return _jsx("div", { className: s.slot, children: startSlot });
};
export default SelectStartContent;
